"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = require("../theme/colors");

var _default = function _default(theme) {
  return {
    uncheckedDefaultBg: {
      backgroundColor: _colors.white
    },
    icon: {
      fill: _colors.blueGray300
    },
    checked: {
      '& #checkboxCheckV': {
        transformOrigin: 'center left',
        animation: '$grow 225ms'
      },
      fill: theme.palette.primary["default"]
    },
    '@keyframes grow': {
      from: {
        transform: 'scale(.3)'
      },
      to: {
        transform: 'scale(1)'
      }
    }
  };
};

exports["default"] = _default;